<template>
  <div class="hero">
    <section v-if="isOverDisplay" class="hero-inner" v-bind:style="{backgroundImage: `url(${backImg})`}" >
      <div class="page-title-set">
        <h3 class="page-title">
            {{title}}<br>{{titleSub}}<br>
          <KurehaArrow class="kureha_arrow" :width="350" />
        </h3>
        <p v-html="text" class="page-catch"></p>
      </div>
    </section>
    <section v-else class="hero-inner" v-bind:style="{backgroundImage: `url(${backImgSp})`}">
      <div class="page-title-set">
        <h3 class="page-title">
            {{title}}<br>{{titleSub}}<br>
          <KurehaArrow class="kureha_arrow" :width="350" />
        </h3>
        <p v-html="text" class="page-catch"></p>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import KurehaArrow from "@/components/icons/KurehaArrow.vue"
export default {
  name: 'hero',
  components: {
    KurehaArrow
  },
  data() {
    return {
      backStyle: `background:${this.backImg}`
    }
  },
  props: {
    backImg: String,
    backImgSp: String,
    title: String,
    titleSub: String,
    text: String,
  },
  computed: {
    isOverDisplay() {
      return window.innerWidth >= 961 ? true: false;
    }
  }
}
</script>

<style scoped lang="scss">
.hero {
  position: relative;
}
.hero-inner {
  height: 500px;
  background-position: center;
  background-size: cover;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  @media print, screen and (max-width: 960px) {
    height: 300px;
  }
}
.page-title-set {
  text-align: center;
  width: 90%;
  letter-spacing: 0.1em;
}
.page-title {
  letter-spacing: 0.1em;
  line-height: 1.5em;
  display: inline-block;
  color: #fff;
  font-size: 42px;
  text-align: center;
  margin-bottom: 0.5em;
  margin-top:0;
  display: inline-block;
  width: auto;
  position: relative;
  @media print, screen and (max-width: 597px) {
    font-size: 22px;
  }
  br:first-child{
    display:none;
  }
}
.page-catch {
  font-size: 20px;
  line-height: 1.8em;
  color: #fff;
  text-align: center;
  font-weight: bold;
  margin: 0;
  margin-top: 1em;
  @media print, screen and (max-width: 597px) {
    font-size: 14px;
  }
}
.kureha_arrow {
  position: absolute;
  display: block;
  width: auto;
  bottom: -30%;
  @media all and (-ms-high-contrast: none) {//IEで位置がずれるため
  height:50%;
  }
}

</style>
